import {DetailedHTMLProps, ElementType, HTMLAttributes, ReactNode} from 'react';
import {Tabs as MUITabs, Tab as MUITab, Box, TabProps as MUITabProps} from '@mui/material';
import {styled} from '@mui/material/styles';

interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

export const Tabs = styled((props: StyledTabsProps) => (
  <MUITabs variant="fullWidth" centered {...props} />
))(({theme}) => ({
  minHeight: 'unset',
  height: theme.spacing(5.5),
  '.MuiTabs-indicator': {
    backgroundColor: 'var(--dcm-blue-base)',
  },
}));

interface StyledTabProps extends MUITabProps {
  label: string;
  component?: ElementType<any>;
  to?: string;
}

export const Tab = styled((props: StyledTabProps) => <MUITab disableRipple {...props} />)(
  ({theme}) => ({
    minHeight: 'unset',
    height: theme.spacing(5.5),
    textTransform: 'none',
    fontFamily: 'Roboto',
    fontSize: '16px',
    letterSpacing: 0,
    fontWeight: 400,
    lineHeight: '18.75px',
    color: 'var(--dcm-gray)',
    borderBottom: '2px solid var(--dcm-gray-lightbg)',
    '&.Mui-selected': {
      fontWeight: 500,
      color: 'var(--dcm-blue-base)',
    },
  })
);

interface TabPanelProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  children?: ReactNode;
  index: number;
  value: number;
}

export const TabPanel = (props: TabPanelProps) => {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
};
